<template>
  <div
    ref="card"
    class="multi-select"
    :class="activeOptions ? 'activeOptions' : ''" >

    <div class="w-full input-icon-layout" :class="selectItem.length > 0 ? 'items' : ''" @click.stop="onClickInputIconLayout">
      <div class="inline-flex gap-2" style="padding: 0.5rem; flex-wrap: wrap; ">
        <template v-for="item in realData">
          <span v-if="item === '전체'" class="px-2" style="display: flex; align-items: center;">{{ item }}</span>
          <item-chip v-else :label="item" @close="onCloseItem" />
        </template>
      </div>
      <div style="cursor: pointer">
        <i class="vs-icon notranslate icon-scale icon-select vs-select--icon material-icons null" style="cursor: pointer">keyboard_arrow_down</i>
      </div>
    </div>

    <div class="multi-select-options mt-2 vs-select--options">
      <div class="p-2 multi-select-option-search">
        <search-nav-item-keyword label=""
                                 v-model="searchOptionKeyword"
                                 placeholder="검색어를 입력하세요."
                                 @click.stop/>
      </div>
      <ul>
        <li v-for="option in getOptions"
            :key="`options_${option}_${id}`"
            class="p-2 vs-select--item"
            :class="{'activex':selectItem.includes(option)}"
            @click.stop="onClickItem(option)">
          <vs-checkbox :checked="selectItem.includes(option)" @click.stop>{{option}}</vs-checkbox>
        </li>
      </ul>
      <div class="p-2">
        <vs-button class="w-full" color="#7E72F2" @click.stop="saveData">
          <!-- vs-select--options 에서 사용되는 span 의 color 가 지정되어 있어서 인스타일로 재정의 -->
          <span style="color: #fff">적용</span>
        </vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import ItemChip from "@/components/multi-select/ItemChip.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";

export default {
  name: "MultiSelect",
  components: {SearchNavItemKeyword, ItemChip},
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: Array,
  },
  watch:{
    activeOptions(){
      if(this.activeOptions) {
        window.addEventListener('click', this.onOutsideClick);
      } else {
        window.removeEventListener('click', this.onOutsideClick);
      }

      if (this.activeOptions) {
        if (this.value) {
          this.selectItem = this.value;
        } else {
          this.selectItem = [];
        }
      } else {
        this.selectItem = [];
      }
    },
  },
  computed: {
    realData() {
      if (this.value) {
        return this.value;
      }
      return []
    },
    getOptions(){
      return this.options.filter((option) => option.includes(this.searchOptionKeyword));
    }
  },
  data() {
    return {
      id: new Date().getTime(),
      activeOptions: false,
      selectItem: [],

      searchOptionKeyword: '',
    }
  },
  created() {
    // <multi-select> 컴포넌트를 여러개 사용할 경우,
    // 하나의 <multi-select> 의 options 만 보여주기 위해서 eventbus 활용.
    this.$eventbus.$on('multi-select-toggled', (id) => {
      if (this.id !== id) {
        this.activeOptions = false;
      }
    });
  },
  methods: {
    saveData () {
      this.$emit('input', this.selectItem)
      this.activeOptions = false;
    },
    onClickItem (option) {
      if (this.selectItem.includes(option)) {
        this.selectItem = this.selectItem.filter((item) => item !== option)
      } else {
        if (option === '전체') {
          this.selectItem = ['전체']
        } else {
          this.selectItem = this.selectItem.filter((item) => item !== '전체')
          this.selectItem.push(option)
        }
      }
    },
    onCloseItem (option) {
      if (this.value.includes(option)) {
        this.$emit('input', this.value.filter((item) => item !== option))
        this.activeOptions = false;
      }
    },

    onClickInputIconLayout () {
      this.activeOptions = !this.activeOptions;

      // <multi-select> 컴포넌트를 여러개 사용할 경우,
      // 하나의 options 만 보여주기 위해서 eventbus 활용.
      if (this.activeOptions) {
        this.$eventbus.$emit('multi-select-toggled', this.id);
      }
    },

    onOutsideClick(e){
      if(e.target !== this.$refs.card){
        this.activeOptions = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
.multi-select {
  position: relative;

  &.activeOptions i{
    -webkit-transform: translateY(-50%) rotate(-180deg);
    transform: translateY(-50%) rotate(-180deg);
  }

  .input-icon-layout {
    cursor: pointer;

    &.items {
      cursor: initial;
    }
  }

}
.input-icon-layout {
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}

.input-icon-layout {
  display: grid;
  grid-template-columns: 1fr 24px;

  border:1px solid #cdcdcd;
  border-radius: 5px;
  background-color: #fff;

  min-height: 42px;

  position: relative;
}

.multi-select-options {
  display: none;

  width: 100%;
  position: absolute;
  background-color: #fff;
  z-index: 530001;
}
.multi-select-option-search {
  border-bottom: 1px solid #DCDFE2B2;
}

/* on/off 관련 */
.multi-select {
  &.activeOptions{
    .multi-select-options {
      display: block;
    }

    .input-icon-layout {
      cursor: initial;
    }
  }
}
</style>
